import { createHash } from 'node:crypto';
function sha1(bytes) {
    if (Array.isArray(bytes)) {
        bytes = Buffer.from(bytes);
    }
    else if (typeof bytes === 'string') {
        bytes = Buffer.from(bytes, 'utf8');
    }
    return createHash('sha1').update(bytes).digest();
}
export default sha1;
